import apiService from "../services/apiService";

const loginObj = JSON.parse(localStorage.getItem("auth")) || {};
const productsUrl = "accountingapi/GetProductCategories/";

export const getProductCategories = async () => {
  const response = await apiService.get(
    `${productsUrl}?org=${loginObj.org}&is_archive=false`
  );
  return response;
};

export async function createProductCategory(payload) {
  const response = await apiService.post(`${productsUrl}?org=${loginObj.org}`, {
    ...payload,
    org: loginObj.org,
  });

  return response;
}

export async function updateProductCategory(id, payload) {
  const response = await apiService.patch(
    `${productsUrl}${id}/?org=${loginObj.org}`,
    { ...payload, org: loginObj.org }
  );
  return response;
}
